import React, { Fragment, useState } from "react";
import { Dialog, Disclosure, Popover, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  XMarkIcon,
  PlusCircleIcon,
  MinusCircleIcon,
} from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  DocumentTextIcon,
  CalculatorIcon,
} from "@heroicons/react/20/solid";
// import SignUp from "./SignUp";
import SignIn from "../userAuth/SignIn";
import { Link } from "react-router-dom";

const callsToAction = [
  { name: "Read our Blogs", href: "", icon: DocumentTextIcon },
  { name: "Get Quote", href: "", icon: CalculatorIcon },
];

const insuranceCategories = [
  {
    title: "Health Insurance",
    items: [
      {
        name: "Best Health Insurance Plans",
        link: "/customer/health-insurance",
      },
      { name: "Family Health Insurance", link: "/customer/health-insurance" },
      {
        name: "Senior Citizen Health Insurance",
        link: "/customer/health-insurance",
      },
      {
        name: "Health Insurance for Children",
        link: "/customer/health-insurance",
      },
      { name: "Critical Illness", link: "/customer/health-insurance" },
      { name: "Medical Inspection", link: "/customer/health-insurance" },
      { name: "Top-up Health Insurance", link: "/customer/health-insurance" },
    ],
  },
  {
    title: "Car Insurance",
    items: [
      {
        name: "Standalone Own Damage",
        link: "/customer/motor-insurance/4wheeler/?source=standalone-own-damage",
      },
      {
        name: "Comprehensive Car Insurance",
        link: "/customer/motor-insurance/4wheeler/?source=comprehensive-car-insurance",
      },
      {
        name: "Car Insurance Renewal",
        link: "/customer/motor-insurance/4wheeler/?source=car-insurance-renewal",
      },
      {
        name: "Cashless Garages",
        link: "/customer/motor-insurance/4wheeler/?source=cashless-garages",
      },
      {
        name: "Personal Accident",
        link: "/customer/motor-insurance/4wheeler/?source=personal-accident",
      },
      {
        name: "Zero Depreciation",
        link: "/customer/motor-insurance/4wheeler/?source=zero-depreciation",
      },
    ],
  },
  {
    title: "Bike Insurance",
    items: [
      {
        name: "Standalone Own Damage",
        link: "/customer/motor-insurance/2wheeler/",
      },
      {
        name: "Comprehensive Bike Insurance",
        link: "/customer/motor-insurance/2wheeler/",
      },
      {
        name: "Bike Insurance Renewal",
        link: "/customer/motor-insurance/2wheeler/",
      },
      { name: "Cashless Garages", link: "/customer/motor-insurance/2wheeler/" },
      {
        name: "Third Party Insurance",
        link: "/customer/motor-insurance/2wheeler/",
      },
      {
        name: "Zero Depreciation",
        link: "/customer/motor-insurance/2wheeler/",
      },
    ],
  },
  {
    title: "Life Insurance",
    items: [
      {
        name: "Human Life Value",
        link: "/human-life-value/?source=human-life-value",
      },
      {
        name: "Benefits Of Life Insurance",
        link: "/life-insurance/?source=benefits-life-insurance",
      },
      {
        name: "Life Insurance Coverages",
        link: "/life-insurance/?source=life-insurance-coverages",
      },
      { name: "Term Insurance Vs Life Insurance", link: "#" },
      {
        name: "Benefits of Term Insurance",
        link: "/term-insurance/?source=benefits-of-term-insurance",
      },
      {
        name: "Group Term Life Insurance",
        link: "/term-insurance/?source=group-term-life-insurance",
      },
      {
        name: "NRI Term Insurance Plans",
        link: "/term-insurance/?source=nri-term-insurance-plans",
      },
      {
        name: "ROP(Return of Premium) ",
        link: "#",
      },
    ],
  },

  {
    title: "Investment",
    items: [
      { name: "ULIP Plans", link: "#" },
      { name: "Child Plans", link: "#" },
      {
        name: "Retirement and Pension Plans",
        link: "/investment-plan?source = retirement-pension-plan",
      },

      { name: "Tax Saving Investment", link: "#" },
      { name: "Money Back Policy", link: "#" },
      { name: "SIP Calculator", link: "#" },
      { name: "Guaranteed Return Plan", link: "#" },
    ],
  },
  {
    title: "Other Insurance Products",
    items: [
      {
        name: "Goods Carrying Vehicle Insurance",
        link: "/customer/motor-insurance/gcv/",
      },
      {
        name: "Passenger Carrying Vehicle Insurance",
        link: "/customer/motor-insurance/pcv/",
      },
      { name: "Trailer Insurance", link: "#" },
      { name: "Travel Insurance", link: "#" },
      { name: "Pet Insurance", link: "#" },
      { name: "Home Insurance", link: "#" },
      { name: "Fire Insurance", link: "#" },
      { name: "Solar Insurance", link: "/solar-insurance" },
    ],
  },
  {
    title: "Business Insurance",
    items: [
      {
        name: "Group Health Insurance",
        image:
          "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/group-health.svg",
        link: "/group-health-insurance",
      },
      {
        name: "Group Personal Accident",
        image:
          "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/group-personal-accident.svg",
        link: "/group-personal-accident",
      },

      {
        name: "Shopkeepers Insurance",
        image:
          "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/shopkeepers-insurance.svg",
        link: "/shop-package",
      },
      {
        name: "Workmen Compensation",
        image:
          "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/workmen-compensation.svg",
        link: "/workmen-compensation-insurance",
      },
      {
        name: "Contractor’s Plant & Machinery",
        image:
          "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/contractor-plants-machinery.svg",
        link: "/contractor-plant-machinery",
      },

      {
        name: "Professional and Doctor’s Indemnity",
        image:
          "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/professional-doctors-indemnity.svg",
        link: "/doctors-indemnity-insurance",
      },
      {
        name: "Office Package",
        image:
          "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/office-package.svg",
        link: "/office-package-insurance",
      },
      {
        name: "Surety Bonds",
        link: "/surety-bond",
      },
    ],
  },
];

const renewalCategories = [
  {
    title: "Renewal Categories",
    items: [
      { name: "Health Insurance Renewal", link: "/customer/health-insurance" },
      {
        name: "Car Insurance Renewal",
        link: "/customer/motor-insurance/4wheeler/",
      },
      {
        name: "Bike Insurance Renewal",
        link: "/customer/motor-insurance/2wheeler/",
      },
      { name: "Term Insurance Renewal", link: "#" },
      { name: "Life Insurance Renewal", link: "#" },
      { name: "Travel Insurance Renewal", link: "#" },
      { name: "Pet Insurance Renewal", link: "#" },
    ],
  },
  {
    title: "Other Renewal Categories",
    items: [
      { name: "GCV Insurance Renewal", link: "/customer/motor-insurance/gcv/" },
      { name: "PCV Insurance Renewal", link: "#" },
      { name: "Trailer Insurance Renewal", link: "#" },
      { name: "Investment Plans Renewal", link: "#" },
      { name: "Home Insurance Renewal", link: "#" },
      { name: "Fire Insurance Renewal", link: "#" },
    ],
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="">
      <nav
        className="px-10 lg:px-16 py-2 mx-auto flex w-full h-auto items-center justify-between shadow-md fixed bg-white z-[50]"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <Link to="/" alt="company logo" className="-m-1.5 ">
            <img
              src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/acuvisor.png"
              alt="Picture of the author"
              className="p-2 w-[60%] h-auto pb-2"
            />
          </Link>
        </div>

        {/* hamburger icon */}
        <div className="flex lg:hidden">
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-md text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>

        <div className="hidden lg:flex lg:justify-between">
          <Popover.Group className="hidden lg:flex lg:gap-x-8 items-center">
            <Popover className="relative">
              <Popover.Button
                className="flex items-center gap-x-1 text-md font-medium leading-6 
              text-gray-900 hover:bg-gradient-to-r from-green-500 to-teal-500 
            hover:text-transparent hover:bg-clip-text focus:outline-none group"
              >
                SecureShields
                <ChevronDownIcon
                  className="h-5 w-5 flex-none text-gray-400 group-open:-rotate-180 ease-in-out
                  "
                  aria-hidden="true"
                />
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute inset-x-0 -left-52 top-full mt-3 w-screen max-w-5xl overflow-y-auto overflow-x-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 max-h-[85vh] scrollbar-hide">
                  <div className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                      {insuranceCategories.map((category) => (
                        <div key={category.title} className="px-4">
                          <h2 className="text-lg font-semibold">
                            {category.title}
                          </h2>
                          <ul className="text-sm flex flex-col gap-y-1 text-start w-48 pl-0">
                            {category.items.map((item) => (
                              <li key={item.name}>
                                <Link
                                  to={item.link}
                                  className="hover:text-blue-500 transition-colors duration-200 no-underline text-slate-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                    {callsToAction.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                      >
                        <item.icon
                          className="h-5 w-5 flex-none text-gray-400"
                          aria-hidden="true"
                        />
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </Popover.Panel>
              </Transition>
            </Popover>
            <Popover className="relative">
              <Popover.Button
                className="flex items-center gap-x-1 text-md font-medium leading-6 
              text-gray-900 hover:bg-gradient-to-r from-green-500 to-teal-500 
            hover:text-transparent hover:bg-clip-text focus:outline-none"
              >
                ExtendCare
                <ChevronDownIcon
                  className="h-5 w-5 flex-none text-gray-400"
                  aria-hidden="true"
                />
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute left-1/2 transform -translate-x-1/2 top-full z-10 mt-3 w-screen max-w-2xl overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                  <div className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                      {renewalCategories.map((category) => (
                        <div key={category.title} className="px-4">
                          <h2 className="text-lg font-semibold">
                            {category.title}
                          </h2>
                          <ul className="text-sm flex flex-col gap-y-1 text-start w-48 pl-0">
                            {category.items.map((item) => (
                              <li key={item.name}>
                                <Link
                                  to={item.link}
                                  className="hover:text-blue-500 transition-colors duration-200 no-underline text-slate-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                    {callsToAction.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                      >
                        <item.icon
                          className="h-5 w-5 flex-none text-gray-400"
                          aria-hidden="true"
                        />
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </Popover.Panel>
              </Transition>
            </Popover>

            <div
              className="text-md font-medium leading-6 text-gray-900 
            hover:bg-gradient-to-r from-green-500 to-teal-500 
            hover:text-transparent hover:bg-clip-text focus:outline-none"
            >
              ClaimsEase
            </div>

            <a
              className="no-underline"
              href="https://play.google.com/store/apps/details?id=com.acuvisor.android"
            >
              <div
                className="text-sm font-medium leading-6  px-2 py-1 border-2 text-green-600 border-green-400 rounded-lg shadow-md 
  hover:border-green-500 hover:shadow-lg hover:bg-gradient-to-r from-green-400 to-teal-400 
  focus:outline-none focus:ring-2 focus:ring-green-300 hover:text-white transition-all duration-300 ease-in-out"
              >
                Become a POSP
              </div>
            </a>

            <div
              className="text-sm font-medium .leading-6 text-gray-900 px-2 py-1 border-2 shadow border-blue-300 rounded-lg 
            hover:bg-customBlue-200 hover:shadow-sm focus:outline-none flex group transition ease-in duration-300"
            >
              <img
                className="w-6 h-6 p-1 bg-contain"
                src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/talktoexpert.gif"
                alt="acuvisor-talk-to-expert-tellephone-icon"
              ></img>
              <span>ShieldSupports</span>
              <span className="h-16 w-32 absolute bg-transparent hidden group-hover:block "></span>
              <ul className="hidden absolute top-16 p-4 w-64 bg-gray-50 rounded-tr-2xl rounded-bl-2xl shadow group-hover:flex flex-col justify-center ">
                <a
                  href="tel:020-40065077"
                  className="no-underline text-inherit "
                >
                  <li className="bg-purple-50 border-b flex content-center justify-center">
                    <img
                      src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/icon.png"
                      alt="call-our-expert-icon"
                      className="w-14 h-14 bg-contain p-1"
                    />
                    <div className="flex flex-col p-2 justify-center ">
                      <span className="pb-0 text-xs"> Call Our Landline</span>
                      <span className="pb-0 text-sm font-semibold">
                        {" "}
                        +91 020-40065077
                      </span>
                    </div>
                  </li>
                </a>
                <a
                  href={"tel:9930404202"}
                  className="no-underline text-inherit "
                >
                  <li className="bg-blue-50 border-b flex content-center justify-center">
                    <img
                      src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/icon+(2).png"
                      alt="call-our-expert-icon"
                      className="w-14 h-14 bg-contain p-1"
                    />
                    <div className="flex flex-col p-2 justify-center ">
                      <span className="pb-0 text-xs"> Call Our Mobile</span>
                      <span className="pb-0 text-sm font-semibold">
                        {" "}
                        +91 9930404202
                      </span>
                    </div>
                  </li>
                </a>
              </ul>
            </div>

            <SignIn />
          </Popover.Group>
        </div>
      </nav>

      {/* phone hamburger */}
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-[50] w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="#" className="-m-1.5 p-1.5">
              <img
                className="h-8 w-auto"
                src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/logo+3.png"
                alt=""
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-lg font-medium leading-7 hover:bg-gray-50">
                        SecureShields
                        <ChevronDownIcon
                          className={classNames(
                            open ? "rotate-180" : "",
                            "h-5 w-5 flex-none",
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {insuranceCategories.map((category) => (
                          <Disclosure as="div" className="-mx-3">
                            {({ open }) => (
                              <div key={category.title} className="px-4">
                                <Disclosure.Button className="text-base font-semibold flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 leading-7 hover:bg-gray-50">
                                  {category.title}
                                  {open ? (
                                    <MinusCircleIcon
                                      className="h-5 w-5 flex-none"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <PlusCircleIcon
                                      className="h-5 w-5 flex-none"
                                      aria-hidden="true"
                                    />
                                  )}
                                </Disclosure.Button>
                                <Disclosure.Panel className="mt-2 space-y-2">
                                  <ul className="text-sm flex flex-col gap-y-1 text-start w-48 rounded-lg pl-0 pb-2 ml-6 pr-3.5">
                                    {category.items.map((item) => (
                                      <li key={item.name}>
                                        <Link
                                          to={item.link}
                                          className="hover:text-blue-500 transition-colors duration-200 no-underline text-slate-700"
                                        >
                                          {item.name}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </Disclosure.Panel>
                              </div>
                            )}
                          </Disclosure>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-lg font-medium leading-7 hover:bg-gray-50">
                        ExtendCare
                        <ChevronDownIcon
                          className={classNames(
                            open ? "rotate-180" : "",
                            "h-5 w-5 flex-none",
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {renewalCategories.map((category) => (
                          <Disclosure as="div" className="-mx-3">
                            {({ open }) => (
                              <div key={category.title} className="px-4">
                                <Disclosure.Button className="text-base font-semibold flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 leading-7 hover:bg-gray-50">
                                  {category.title}
                                  {open ? (
                                    <MinusCircleIcon
                                      className="h-5 w-5 flex-none"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <PlusCircleIcon
                                      className="h-5 w-5 flex-none"
                                      aria-hidden="true"
                                    />
                                  )}
                                </Disclosure.Button>
                                <Disclosure.Panel className="mt-2 space-y-2">
                                  <ul className="text-sm flex flex-col gap-y-1 text-start w-48 rounded-lg pl-0 pb-2 ml-6 pr-3.5">
                                    {category.items.map((item) => (
                                      <li key={item.name}>
                                        <Link
                                          to={item.link}
                                          className="hover:text-blue-500 transition-colors duration-200 no-underline text-slate-700"
                                        >
                                          {item.name}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </Disclosure.Panel>
                              </div>
                            )}
                          </Disclosure>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>

                <div className="-mx-3 block rounded-lg px-3 py-2 text-lg font-medium leading-7 text-gray-900 hover:bg-gray-100">
                  ClaimsEase
                </div>
                <div className="-mx-3 block rounded-lg px-3 py-2 text-base font-medium leading-7 text-gray-900 hover:bg-gray-100 border-blue-300">
                  {/* Shows Sign In button if not logged in otherwise profile hover menu */}
                  <SignIn />
                </div>
              </div>
              <div className="py-3">
                <div className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-medium leading-7 text-gray-900 hover:bg-gray-100">
                  Become a POSP With Us
                </div>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
}

export default Navbar;
